<div class="card p-4 surface-card border-round-md shadow-2">
    <h2 class="mb-3">Settlements List</h2>
    <p-toolbar styleClass="mb-4">
        <div class="p-toolbar-group-start">
            <p-button label="New Settlement" icon="pi pi-plus" styleClass="p-button-success"
                (click)="onNewSettlement()"></p-button>
        </div>
        <div class="p-toolbar-group-end">
            <p-button label="Export" icon="pi pi-upload" styleClass="p-button-help" (click)="exportExcel()"
                [loading]="isExporting"></p-button>
        </div>
    </p-toolbar>

    <div class="card p-4 surface-card border-round-md shadow-2 mb-4">
        <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
            <div class="grid formgrid p-fluid">
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText type="number" formControlName="id" id="id" class="w-full">
                            <label for="id">Settlement ID</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <app-entity-dropdown-multiselect-picker formControlName="salesRepNames"
                    [adapter]="salesRepPickerAdapter" inputId="salesRep" label="Sales Rep"
                    placeholder="Select sales reps" filterPlaceholder="Filter sales reps" addonIconClass="pi pi-user"
                    [searchPageSize]="25" [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-check-square"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-multiSelect formControlName="statuses" [options]="statuses" inputId="status"
                                styleClass="w-full" [showClear]="true" display="chip">
                            </p-multiSelect>
                            <label for="status">Status</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <app-entity-dropdown-picker formControlName="customers" [adapter]="customerPickerAdapter"
                    inputId="customer" label="Customer" placeholder="Select a customer"
                    filterPlaceholder="Filter customers" addonIconClass="pi pi-users"
                    columnClass="col-12 md:col-8 lg:col-8"></app-entity-dropdown-picker>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-globe"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="channels" id="channel" class="w-full">
                            <label for="channel">Channel</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <app-entity-dropdown-multiselect-picker formControlName="branchNames" [adapter]="branchPickerAdapter"
                    inputId="branch" label="Branch" placeholder="Select branches" filterPlaceholder="Filter branches"
                    addonIconClass="pi pi-building" [searchPageSize]="25" [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker formControlName="businessUnitNames"
                    [adapter]="businessUnitPickerAdapter" inputId="businessUnit" label="Business Unit"
                    placeholder="Select business units" filterPlaceholder="Filter business units"
                    addonIconClass="pi pi-briefcase" [searchPageSize]="25" [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-picker formControlName="promoPlanIds" [adapter]="promoPlanPickerAdapter"
                    inputId="promoPlan" label="Promo Plan" placeholder="Select a promo plan"
                    filterPlaceholder="Filter promo plans" addonIconClass="pi pi-calendar"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-picker>
                <app-entity-dropdown-multiselect-picker formControlName="businessNames"
                    [adapter]="businessPickerAdapter" inputId="business" label="Business"
                    placeholder="Select businesses" filterPlaceholder="Filter businesses"
                    addonIconClass="pi pi-briefcase" [searchPageSize]="25" [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker formControlName="supplierNames"
                    [adapter]="supplierPickerAdapter" inputId="supplier" label="Supplier" placeholder="Select suppliers"
                    filterPlaceholder="Filter suppliers" addonIconClass="pi pi-truck" [searchPageSize]="25"
                    [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <app-entity-dropdown-multiselect-picker formControlName="activityTypeNames"
                    [adapter]="activityTypePickerAdapter" inputId="activityType" label="Activity Type"
                    placeholder="Select activity types" filterPlaceholder="Filter activity types"
                    addonIconClass="pi pi-bolt" [searchPageSize]="25" [searchMinLength]="0"
                    columnClass="col-12 md:col-6 lg:col-4"></app-entity-dropdown-multiselect-picker>
                <div class="field col-12 md:col-6 lg:col-4">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-file-excel"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="customerInvoiceNumbers" id="customerInvoiceNumber"
                                class="w-full">
                            <label for="customerInvoiceNumber">Customer Invoice Number</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="actualStartDate" dateFormat="yy-mm-dd"
                                inputId="actualStartDate" [showIcon]="true" [style]="{'width': '100%'}"
                                class="w-full"></p-calendar>
                            <label for="actualStartDate">Actual Start Date</label>
                        </p-iftalabel>
                        <p-inputgroup-addon>
                            <p-dropdown [options]="startDateOptions" formControlName="actualStartDateOption"
                                inputId="actualStartDateOption" [style]="{'width': '250px'}"
                                [showClear]="true"></p-dropdown>
                        </p-inputgroup-addon>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-6">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="actualEndDate" dateFormat="yy-mm-dd" inputId="actualEndDate"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="actualEndDate">Actual End Date</label>
                        </p-iftalabel>
                        <p-inputgroup-addon>
                            <p-dropdown [options]="endDateOptions" formControlName="actualEndDateOption"
                                inputId="actualEndDateOption" [style]="{'width': '250px'}"
                                [showClear]="true"></p-dropdown>
                        </p-inputgroup-addon>
                    </p-inputgroup>
                </div>
            </div>
            <div class="flex justify-content-end gap-2 mt-4">
                <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary"
                    (click)="onReset()"></p-button>
                <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
            </div>
        </form>
    </div>

    <p-table #dt [value]="settlements" [rows]="25" [paginator]="true" [loading]="loading" [lazy]="true"
        [autoLayout]="true" (onLazyLoad)="loadSettlements($event)" [totalRecords]="totalRecords"
        [paginatorDropdownAppendTo]="'body'" [tableStyle]="{'min-width': '85rem'}"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[25, 50, 100, 500]">
        <ng-template pTemplate="header">
            <tr>
                <th>Actions</th>
                <th pSortableColumn="id">Settlement ID <p-sortIcon field="id"></p-sortIcon></th>
                <th pSortableColumn="salesRep.fullName">Sales Rep <p-sortIcon field="salesRep.fullName"></p-sortIcon>
                </th>
                <th pSortableColumn="status.statusName">Status <p-sortIcon field="status.statusName"></p-sortIcon></th>
                <th pSortableColumn="promoPlan.promoDescription">Promo Plan <p-sortIcon
                        field="promoPlan.promoDescription"></p-sortIcon></th>
                <th pSortableColumn="actualStartDate">Actual Start Date <p-sortIcon
                        field="actualStartDate"></p-sortIcon></th>
                <th pSortableColumn="actualEndDate">Actual End Date <p-sortIcon field="actualEndDate"></p-sortIcon></th>
                <th pSortableColumn="customer.customerNumber">Customer # <p-sortIcon
                        field="customer.customerNumber"></p-sortIcon></th>
                <th pSortableColumn="customer.customerName">Customer Name <p-sortIcon
                        field="customer.customerName"></p-sortIcon></th>
                <th pSortableColumn="customerInvoiceNumber">Customer Invoice # <p-sortIcon
                        field="customerInvoiceNumber"></p-sortIcon></th>
                <th pSortableColumn="channel">Channel <p-sortIcon field="channel"></p-sortIcon></th>
                <th pSortableColumn="branch.name">Branch <p-sortIcon field="branch.name"></p-sortIcon></th>
                <th pSortableColumn="businessUnit.businessUnitName">Business Unit <p-sortIcon
                        field="businessUnit.name"></p-sortIcon></th>
                <th pSortableColumn="business.businessName">Claim Brand <p-sortIcon
                        field="business.businessName"></p-sortIcon></th>
                <th pSortableColumn="supplier.supplierName">Supplier <p-sortIcon
                        field="supplier.supplierName"></p-sortIcon></th>
                <th pSortableColumn="activityType.name">Activity Type <p-sortIcon
                        field="activityType.name"></p-sortIcon></th>
                <th pSortableColumn="note">Note <p-sortIcon field="note"></p-sortIcon></th>
                <th pSortableColumn="value">Sales Amount <p-sortIcon field="value"></p-sortIcon></th>
                <th pSortableColumn="vat">VAT <p-sortIcon field="vat"></p-sortIcon></th>
                <th pSortableColumn="totalAmount">Total <p-sortIcon field="totalAmount"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-settlement>
            <tr>
                <td>
                    <p-button icon="pi pi-eye" styleClass="p-button-rounded p-button-info p-button-text"
                        (click)="onViewSettlement(settlement)"></p-button>
                </td>
                <td>{{settlement.id}}</td>
                <td>
                    <p-chip *ngIf="settlement.salesRep?.profilePictureUrl" [label]="settlement.salesRep?.fullName"
                        [image]="settlement.salesRep?.profilePictureUrl" styleClass="p-chip-md"></p-chip>
                    <p-chip *ngIf="!settlement.salesRep?.profilePictureUrl" [label]="settlement.salesRep?.fullName"
                        icon="pi pi-user" styleClass="p-chip-md"></p-chip>
                </td>
                <td>
                    <p-tag [value]="settlement.status?.statusName"
                        [severity]="getStatusSeverity(settlement.status?.statusName)"></p-tag>
                </td>
                <td>{{settlement.promoPlan?.promoDescription}} ({{settlement.promoPlanId}})</td>
                <td>{{ settlement.actualStartDate | appDate: 'dd/MM/yyyy'}}</td>
                <td>{{ settlement.actualEndDate | appDate: 'dd/MM/yyyy'}}</td>
                <td>{{settlement.customer?.customerNumber}}</td>
                <td>{{settlement.customer.customerName}}</td>
                <td>{{settlement.customerInvoiceNumber}}</td>
                <td>{{settlement.channel}}</td>
                <td>{{settlement.branch?.name}}</td>
                <td>{{settlement.businessUnit?.businessUnitName}}</td>
                <td>{{settlement.business?.businessName}}</td>
                <td>{{settlement?.supplierName}}</td>
                <td>
                    <p-chip [label]="settlement.activityType.name" [icon]="settlement.activityType.icon"></p-chip>
                </td>
                <td>{{settlement.note}}</td>
                <td>{{settlement.value | currency:'SAR'}}</td>
                <td>{{settlement.vat | currency:'SAR'}}</td>
                <td>{{settlement.totalAmount | currency:'SAR'}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="20" class="text-center">No settlements found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>